import { mapGetters } from "vuex";
export default {
  data() {
    return {
      flags: null,
      fieldConditions: []
    };
  },
  mounted() {},

  computed: {
    ...mapGetters("featureFlag", ["allFlags"])
  }
};
